<template>
	<nk-wrapper v-if="context.brancheneintrag" spacing="md">
		<nk-accordion :title="context.titel || 'Adresse'" title-size="xl" open>
			<nk-row>
				<nk-col cols="shrink" class="hidden sm:block">
					<nk-icon
						icon="map"
						size="2xl"
						:inline="false"
						:background-color="true"
						color="neutral"
						variant="boxed"
					/>
				</nk-col>
				<nk-col cols="auto">
					<nk-title
						v-if="context.brancheneintrag.titel"
						size="lg"
						color="type-dark"
						font-weight="semibold"
					>
						<nk-link
							v-if="context.brancheneintrag.rubriken.length"
							:link="context.brancheneintrag.rubriken[0].detailURL"
						>
							{{ context.brancheneintrag.titel }}
						</nk-link>
						<template v-else>
							{{ context.brancheneintrag.titel }}
						</template>
					</nk-title>
					<nk-address
						v-bind="{
							...context.brancheneintrag.adresse,
							...context.brancheneintrag.kontakt,
						}"
					/>
				</nk-col>
			</nk-row>
		</nk-accordion>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {string} context.titel
 * @prop {object} context.brancheneintrag
 */
export default {
	name: 'NkTemplateBrancheneintrag',
	mixins: [TemplatesDefault],
};
</script>
